import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

const BULK_FIELD_CONTROL_HEIGHT_PX = 56;
const BULK_TEMPLATE_TOP_MARGIN_PX = 21;
const BULK_FIELDS_GAP_PX = 17;

export const BulkFieldsStackStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-fields-stack",
})`
  display: flex;
  flex-direction: column;
  gap: ${BULK_FIELDS_GAP_PX}px;
  width: 100%;
`;

export const BulkRowWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-row-wrapper",
})`
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: 20px;
  align-items: start;

  /* Hide rows when template is missing or empty (hidden by condition / HiddenField) */
  &:not(:has([data-e2e="form-template-wrapper"]:not(:empty))) {
    display: none;
  }

  .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${BULK_TEMPLATE_TOP_MARGIN_PX}px;
    height: ${BULK_FIELD_CONTROL_HEIGHT_PX}px;
  }

  &:has([data-e2e-template="switch-template"]) {
    align-items: center;

    .checkbox-container {
      margin-top: 0;
      height: auto;
    }

    [data-e2e="form-template-wrapper"] {
      margin-top: 0;
    }
  }
`;

export const BulkGroupHeaderWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-group-header-wrapper",
  },
)`
  width: 100%;
`;
